import { Icon, Link, Text } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';
import { useTheme } from '@Sage/hoi-poi-ui';
import { useDomainValidation } from '../../hooks/useDomainValidation';

import './styles.scss';
import { useNavigate } from 'react-router-dom';
import { Markdown } from '@Sage/hoi-poi-ui';

function DomainVerificationBanner() {
    const { hasValidatedDomain, loading } = useDomainValidation();
    const navigate = useNavigate();
    const theme = useTheme();

    if (loading || hasValidatedDomain) return null;

    return (
        <div className="domain-verification-banner">
            <div className="domain-verification-banner__content">
                <Icon name="infoOutlined" color={theme.colors.semantic.caution600} />
                <Markdown
                    overrides={{
                        a: { target: '_blank' },
                    }}
                    content={getLiteral('label_marketing_campaigns_verify_domain_banner')}
                />
            </div>
        </div>
    );
}

DomainVerificationBanner.displayName = 'DomainVerificationBanner';

export default DomainVerificationBanner;
